import { render, staticRenderFns } from "./CategorySelectListItem.vue?vue&type=template&id=891f53e4&scoped=true&"
import script from "./CategorySelectListItem.vue?vue&type=script&lang=js&"
export * from "./CategorySelectListItem.vue?vue&type=script&lang=js&"
import style0 from "./CategorySelectListItem.vue?vue&type=style&index=0&id=891f53e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891f53e4",
  null
  
)

export default component.exports